import { Controller } from "@hotwired/stimulus"

// Chat-bubble nudge to install the site as an app.
// Chrome/Android: waits for beforeinstallprompt, then offers the native prompt.
// iOS Safari and Firefox on Android never fire that event, so they get
// "Add to Home Screen" / browser-menu steps instead.
// Dismissing (or installing) is remembered in localStorage so we only ask once.
const DISMISSED_KEY = "pwa-install-dismissed"

export default class extends Controller {
  static targets = ["installable", "iosSteps", "menuSteps"]

  connect() {
    if (this.standalone || localStorage.getItem(DISMISSED_KEY)) return

    this.promptHandler = (event) => {
      event.preventDefault()
      this.deferredPrompt = event
      this.show(this.installableTarget)
    }
    window.addEventListener("beforeinstallprompt", this.promptHandler)

    if (this.ios) {
      this.show(this.iosStepsTarget)
    } else if (this.firefoxAndroid) {
      this.show(this.menuStepsTarget)
    }
  }

  disconnect() {
    window.removeEventListener("beforeinstallprompt", this.promptHandler)
    clearTimeout(this.showTimer)
  }

  async install() {
    if (!this.deferredPrompt) return
    this.deferredPrompt.prompt()
    await this.deferredPrompt.userChoice
    this.deferredPrompt = null
    this.dismiss()
  }

  dismiss() {
    localStorage.setItem(DISMISSED_KEY, "1")
    this.element.hidden = true
  }

  show(section) {
    section.hidden = false
    // Let guests land on the page before the bubble slides in
    this.showTimer = setTimeout(() => { this.element.hidden = false }, 2500)
  }

  get standalone() {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone
  }

  get ios() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent)
  }

  get firefoxAndroid() {
    return /Android/.test(navigator.userAgent) && /Firefox/.test(navigator.userAgent)
  }
}
